<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>

      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-text>
          <v-row dense>
            <!-- 検索条件エリア -->
            <v-col cols="3">
              <validation-provider v-slot="{ errors }" :name="$t('ELE0127')" rules="required">
                <CompanyInput
                  :label="$t('ELE0127')"
                  @input="onCompanySelect"
                  v-model="searchCondition.inspCompanyCd"
                  value="value"
                  ref="company"
                  :disabled="searchDisableComputed"
                  :companyType="inspCat"
                  :error-messages="errors"
                  required
                />
              </validation-provider>
            </v-col>
            <v-col cols="3">
              <TextFieldInputWithDatePicker
                :label="$t('ELE0128')"
                v-model="searchCondition.dateFrom"
                :disabled="searchDisableComputed"
                @input="onDateChanged"
              />
            </v-col>
            <v-col cols="3">
              <TextFieldInputWithDatePicker
                :label="$t('ELE0129')"
                v-model="searchCondition.dateTo"
                :disabled="searchDisableComputed"
                @input="onDateChanged"
              />
            </v-col>
            <v-col cols="3">
              <validation-provider v-slot="{ errors }" :name="$t('ELE0130')" rules="required">
                <ShiftInput
                  ref="shift"
                  v-model="searchCondition.inspShiftCd"
                  :disabled="searchDisableComputed"
                  :shiftGroupCd="shiftGroupCd"
                  :error-messages="errors"
                  required
                />
              </validation-provider>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <span class="d-flex flex-row justify-end space-x-2 mt-2">
                <BtnSearch class="mr-2" @click="onClickSearch" :disabled="invalid || searchDisableComputed" />
                <BtnReset @click="onClickReset" />
              </span>
            </v-col>
          </v-row>

          <v-row v-if="searchDisableComputed">
            <v-col>
              <v-card outlined>
                <v-card-title class="pt-1 pb-0">
                  {{ invalid ? $t('ELE0023') : $t('ELE0017') }}
                  <v-spacer />
                </v-card-title>
                <v-data-table :headers="headers" :items="dateWithQuantity">
                  <template v-slot:[`item.inspQty`]="{ item }">
                    <div style="max-width: 400px">
                      <TextFieldInput label="" v-model="item.inspQty" type="number" :disabled="invalid" right />
                    </div>
                  </template>
                </v-data-table>
                <v-card-title class="pt-1 pb-2">
                  <v-spacer />
                  <BtnSave @click="onClickSave" :disabled="invalid" />
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </validation-observer>
    </v-container>
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import { ModalMode } from '@/enum'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
// import cloneDeep from 'lodash/cloneDeep'

import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker.vue'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnSave from '@/components/atoms/button/BtnSave'
import IconEdit from '@/components/atoms/icon/IconEdit'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import DefectGroupDialog from '@/components/organisms/master/dialog/DefectGroupDialog.vue'
import moment from 'moment'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput.vue'
import CompanyInput from '@/components/atoms/select/CompanyInput.vue'
import { InspCat } from '@/enum'
import ShiftInput from '@/components/atoms/select/ShiftInput.vue'
import BtnReset from '@/components/atoms/button/BtnReset.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'AnalyzeRecordForm',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    SelectSingleInput,
    TextFieldInputWithDatePicker,
    DefectGroupDialog,
    Checkbox,
    BtnSearch,
    BtnSave,
    IconEdit,
    IconInquiry,
    TextFieldInput,
    CompanyInput,
    ShiftInput,
    BtnReset,
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      dialog: false,
      inspCat: InspCat.OQC_IQC,
      mode: ModalMode.INQUIRY,
      searchCondition: {
        inspCompanyCd: '',
        dateFrom: moment().subtract(1, 'W').format('YYYY-MM-DD'),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        inspShiftCd: '',
      },
      shiftList: [],
      headers: [
        { text: this.$t('ELE0131'), divider: true, value: 'inspDate' },
        { text: this.$t('ELE0132'), divider: false, value: 'inspQty' },
      ],
      dateWithQuantity: [],
      item: [],
      shiftGroupCd: '',
    }
  },
  computed: {
    searchDisableComputed: {
      get() {
        return this.mode !== ModalMode.INQUIRY
      },
      set(value) {
        this.mode = value
      },
    },
  },
  methods: {
    async onCompanySelect(companyCd) {
      if (!companyCd) return
      const shiftGroupCode = this.$refs.company.company?.shiftGroupCd
      this.shiftGroupCd = shiftGroupCode
    },
    async onDateChanged() {
      // if (this.searchCondition.dateFrom && this.searchCondition.dateTo) {
      //   this.onClickSearch()
      // }
    },
    async onClickSearch() {
      this.startLoading()
      try {
        if (moment(this.searchCondition.dateFrom).add(1, 'M') <= moment(this.searchCondition.dateTo)) {
          this.setErrorMessage(this.$t('MSG0101'))
          return
        }
        const params = {
          inspCompanyCd: this.searchCondition.inspCompanyCd,
          dateFrom: this.searchCondition.dateFrom,
          dateTo: this.searchCondition.dateTo,
          inspShiftCd: this.searchCondition.inspShiftCd,
        }
        this.dateWithQuantity = []
        const elements = await API.get('/inspApp/analyzeResult', params)
        const dateRange = this.dateArrayFromRange({
          startDate: this.searchCondition.dateFrom,
          endDate: this.searchCondition.dateTo,
        })
        this.dateWithQuantity = dateRange?.map((element) => {
          return {
            inspDate: element,
            inspQty: elements.find((item) => moment(element).isSame(moment(item['inspDate'])))?.['inspQty'] ?? '',
          }
        })
        this.searchDisableComputed = ModalMode.EDIT
      } catch (error) {
        this.dateWithQuantity = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0133') })))
      } finally {
        this.stopLoading()
      }
    },
    async onClickSave() {
      this.startLoading()
      try {
        const body = {
          inspCompanyCd: this.searchCondition.inspCompanyCd,
          inspShiftCd: this.searchCondition.inspShiftCd,
          dateWithQuantity: this.dateWithQuantity,
        }
        await API.post('/inspApp/analyzeResult/addOrUpdate', body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0132') }))
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0132') })))
      } finally {
        this.stopLoading()
      }
    },
    onClickReset() {
      this.searchDisableComputed = ModalMode.INQUIRY
    },
  },
  mounted() {
    // this.onInit()
  },
}
</script>
